import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { BankTransferInformationDto } from "@modules/+new/payments/features/fiat-deposit/infrastructure/dto/bank-transfer-information.dto";
import { BankAccountInformationType } from "@modules/+new/payments/features/fiat-deposit/domain/entities/manual-deposit/bank-account-information-type.enum";

export interface BankTransferInformation {
	readonly address: string;
	readonly amount: number;
	readonly bank: string;
	readonly bic: string;
	readonly fiatId: number;
	readonly iban: string;
	readonly preferredAccountInformation: BankAccountInformationType;
	readonly receiver: string;
	readonly receiverAddress: string;
	readonly uniquePaymentNumber: string;
	readonly accountNumber: string;
	readonly sortCode: string;
	readonly isGBPBankTransfer: boolean;
}

export class BankTransferInformationAdapter extends BaseAdapter<BankTransferInformationDto, BankTransferInformation> {
	public adapt(item: BankTransferInformationDto): BankTransferInformation {
		if (!item) {
			return null;
		}

		const preferredAccountInformation = <BankAccountInformationType>item.preferred_account_information;

		return {
			address: item.address,
			amount: Number(item.amount),
			bank: item.bank,
			bic: item.bic,
			fiatId: Number(item.fiat_id),
			iban: item.iban,
			preferredAccountInformation,
			receiver: item.receiver,
			receiverAddress: item.receiver_address,
			uniquePaymentNumber: item.unique_payment_number,
			accountNumber: item.account_number,
			sortCode: item.sort_code,
			isGBPBankTransfer: preferredAccountInformation === BankAccountInformationType.Local
		};
	}
}
